var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4335 0.354856C28.9218 -0.055575 28.118 -0.1143 27.2869 0.201267H27.2856C26.4115 0.532967 2.54421 10.2155 1.5726 10.6111C1.39588 10.6692 -0.14751 11.2139 0.0114689 12.4271C0.15339 13.5209 1.39384 13.9739 1.54531 14.0262L7.61312 15.9912C8.01568 17.2587 9.49971 21.9347 9.82791 22.9337C10.0326 23.5565 10.3663 24.3747 10.951 24.5432C11.4641 24.7303 11.9745 24.5593 12.3047 24.3141L16.0144 21.0597L22.0031 25.477L22.1457 25.5576C22.5524 25.728 22.942 25.8132 23.3138 25.8132C23.6011 25.8132 23.8767 25.7622 24.1401 25.6602C25.0373 25.3118 25.3962 24.5032 25.4338 24.4115L29.907 2.42056C30.1799 1.24606 29.8006 0.648482 29.4335 0.354856ZM12.9645 16.7773L10.9176 21.9399L8.87062 15.4866L24.5638 4.51595L12.9645 16.7773Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.dd22132a.svg";
export { ForwardRef as ReactComponent };